module.exports = __webpack_public_path__ + "static/media/banner-khai-khoang.74eeb51e.png";